export default function runFancybox() {
  // All options at http://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.buttons = [
    // "zoom",
    // "share",
    // "slideShow",
    // "fullScreen",
    // "download",
    // "thumbs",
    "close"
  ];

  // if ($("*[data-fancybox]").length > 0) {
  //   // console.log("There are Fancyboxes");
  // }
}